module.exports = __webpack_public_path__ + "public/img/cliente-photo.fc6ec200.svg";